// Shared definitions for the four TSP calendar categories.

export const CATEGORY_KEYS = {
  PRIVATE_VERTICAL: 'private_vertical',
  MY_VERTICAL: 'my_vertical',
  JOINED_VERTICAL: 'joined_vertical',
  OTHER: 'other',
};

// Order used in both the picker dropdown and the sidebar grouping.
export const CATEGORY_ORDER = [
  CATEGORY_KEYS.PRIVATE_VERTICAL,
  CATEGORY_KEYS.MY_VERTICAL,
  CATEGORY_KEYS.JOINED_VERTICAL,
  CATEGORY_KEYS.OTHER,
];

// Labels shown in the picker dropdown (singular).
export const CATEGORY_LABELS = {
  [CATEGORY_KEYS.PRIVATE_VERTICAL]: 'Private Vertical Calendar',
  [CATEGORY_KEYS.MY_VERTICAL]: 'My Vertical Calendar',
  [CATEGORY_KEYS.JOINED_VERTICAL]: 'Joined Vertical Calendar',
  [CATEGORY_KEYS.OTHER]: 'Other Calendar',
};

// Headings shown above each section in the sidebar (plural).
export const CATEGORY_GROUP_LABELS = {
  [CATEGORY_KEYS.PRIVATE_VERTICAL]: 'Private Vertical Calendars',
  [CATEGORY_KEYS.MY_VERTICAL]: 'My Vertical Calendars',
  [CATEGORY_KEYS.JOINED_VERTICAL]: 'Joined Vertical Calendars',
  [CATEGORY_KEYS.OTHER]: 'Other Calendars',
};

export const DEFAULT_CATEGORY = CATEGORY_KEYS.OTHER;
